import axios from 'axios';
import type { ClerkAiAskResponse } from '@/models/clerkAiTypes';

// The AI service can take well over a minute on a multi-step question.
const ASK_TIMEOUT_MS = 3 * 60 * 1000;

export default {
  async ask(query: string, context: string): Promise<ClerkAiAskResponse> {
    const { data } = await axios.post(
      'insights/ask',
      { query, context },
      { timeout: ASK_TIMEOUT_MS },
    );
    return data;
  },
};
